import { render } from "./FirstLogin.vue?vue&type=template&id=6bcd7aa7"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"
script.render = render

export default script